import {req as aqfe_request} from "@/axios/aqfe"

export const FcstEditedRepo = {
    get: (query) => aqfe_request("get", 'fcst_edited/', query),
    post: (data) => aqfe_request("post", 'fcst_edited/', data)
}